import React from 'react';
import {connect} from 'react-redux';
import './styles.less';

import MmgWidget from '@homeaway/react-mmg-widget';

export function mapStateToProps(state) {
    return {
        mmgLinks: state.mmgLinks,
        isMobile: state.config.deviceType === 'mobile'
    };
}

export class MmgLinksComponent extends React.Component {
    static defaultProps = {
        mmgLinks: []
    };

    render() {
        const {mmgLinks, isMobile} = this.props;

        return (mmgLinks.length > 0) ? (
            <div className="mmg-links-container module module--no-padding">
                <MmgWidget categories={mmgLinks} isMobile={isMobile}/>
            </div>
        ) : null;
    }
}

export const MmgLinks = connect(mapStateToProps)(MmgLinksComponent);
